(function() {
	'use strict';
	var $ = avm.require('jquery'),
		unserializeUrl = avm.require('avast.url.unserialize'),
		params = unserializeUrl(window.location.path),
		$phoneLink = $('.js-phone-link'),
		phoneNumbers = {
			'au1': '1800-624-759',
			'gb1': '0800 085 7849',
			'us1': '1-844-258-4517',
			'ca1': '1-844-258-4517',
			'za1': '0800 203 790',
			'nz1': '0508 751 025'
		};

// Dynamic phone number insertion
	if (!$.isEmptyObject(params)) {
		for (var key in params) {
			if (params.hasOwnProperty(key) && key === 'country') {
				if (typeof phoneNumbers[params[key]] !== 'undefined') {
					$phoneLink.attr('href', 'tel:' + phoneNumbers[params[key]]);
					$phoneLink.text(phoneNumbers[params[key]]);
				}
			}
		}
	}
})();
